/*** IMPORTS FROM imports-loader ***/
var define = false;

const YearSelector = {
    init: function () {
      const dropdownToggle = document.querySelector('.site-title a.current');

      if (dropdownToggle) {
        const dropdownWrapper = dropdownToggle.parentElement;

        dropdownToggle.addEventListener('click', (evt) => {
          evt.preventDefault();
          console.log(dropdownWrapper);
          dropdownWrapper.classList.toggle('open');
        });
      }
    },
};

export default YearSelector;

